import { Component, Input, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { FormAlert } from '../../model/form-alert';
import { clearFormAlert } from '../../redux/core.actions';
import { CoreState } from '../../redux/core.reducer';

@Component({
  selector: 'form-error-alert',
  templateUrl: './form-error.component.html',
  standalone: false,
  styleUrls: ['form-error.component.scss']
})
export class FormErrorComponent {
  private readonly store = inject<Store<CoreState>>(Store);

  @Input() globalFormError$!: Observable<FormAlert | undefined>;

  closed() {
    this.store.dispatch(clearFormAlert());
  }
}
